import styles from "./Hero.module.less";
import clsx from "clsx";

export const HeroTitle = ({ multiLine = false, children }) => {
  return <h1 className={clsx(styles.HeroTitle, multiLine && styles.MultiLine)}>{children}</h1>;
};
